import Repository from "./Repository";

const resource = "/version";
export default {
  get() {
    return Repository.get(`${resource}`);
  }
};
